import { useQuery } from '@apollo/client'
import { SearchableCombobox, TSearchable } from '../base/combobox'
import { AssetTypeSelectorQuery, SelectedAssetTypeSelectorQuery } from './__generated__/selector_query'
import { Query, SelectedQuery } from './selector_query'
import { dedupe } from '@/helpers/dedupe'
import { useCombobox } from '@/helpers/useCombobox'

type AssetType = SelectedAssetTypeSelectorQuery['assetTypes']['nodes'][0]

interface Props {
  value: string
  onChange: (value: TSearchable | null) => void
  invalid: boolean
}

export const Selector = ({ value, onChange, invalid }: Props) => {
  const { data: selectedData } = useQuery<SelectedAssetTypeSelectorQuery>(
    SelectedQuery,
    { variables: { id: value || 'blank' } }
  )
  const { data, loading, refetch, fetchMore } = useQuery<AssetTypeSelectorQuery>(Query, { variables: { first: 10 } })

  const { pageInfo, items } = useCombobox<AssetType>({
    pageInfo: data?.assetTypes.pageInfo,
    querySelected: selectedData?.assetTypes.nodes[0],
    queryCollection: data?.assetTypes.nodes,
    buildSearchable: item => ({
      id: item.id,
      name: item.name,
    })
  })

  return (
    <SearchableCombobox
      data={items}
      invalid={invalid}
      loading={loading}
      moreToFetch={pageInfo.current?.hasNextPage}
      refetch={refetch}
      searchField="nameCont"
      value={items.find(d => d.id == value) || { id: '', name: '' }}
      fetchMore={() => fetchMore({
        variables: { after: pageInfo.current?.endCursor },
        updateQuery(previousData, { fetchMoreResult }) {
          if (Object.keys(previousData).length === 0) return fetchMoreResult
          fetchMoreResult.assetTypes.nodes = dedupe([
            ...previousData.assetTypes.nodes,
            ...fetchMoreResult.assetTypes.nodes
          ])

          return { ...fetchMoreResult }
        }
      })}
      onChange={onChange}
    />
  )
}
